import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { IndentDetailPage } from "@/features/stores/components/indent-pages";

export const Route = createFileRoute("/_app/processing/store-indents/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("stores.indent.raise.processing"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <IndentDetailPage key={id} id={Number(id)} area="processing" />;
}
